export const environment = {
  production: true,
  api_url: 'https://admin.codehospitality.co.uk/api/admin/',
};



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/environments/environment.ts